module.exports = __webpack_public_path__ + "img/용산역 고기집.5492572c.png";